import { JobStatus } from "../types/enums/JobStatus";

export const isActiveJobStatus = (status: JobStatus) =>
  status === JobStatus.PENDING || status === JobStatus.PROCESSING;
